import { Component, Output } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { SideNavService } from 'src/app/core-flc/sidenav/sidenav.service';
import { RouterLinkEnum } from 'src/app/enums/router-link-enum';
import { GravelCalcType, LoadChainageDto } from 'src/app/server-api/models';
import { LoadChainageControllerService, TunnelSectionControllerService } from 'src/app/server-api/services';
import { AlertComponent } from 'src/app/utils-flc/alert/alert.component';
import { DetailComponent } from 'src/app/utils-flc/detail/detail.component';
import { DialogRecalucateQueueComponent } from '../../sections/dialog-recalucate-queue/dialog-recalucate-queue.component';
import { ILoadChainageFormGroup } from './ILoadChainageFormGroup';

@Component({
  selector: 'app-load-chainage',
  templateUrl: './load-chainage.component.html',
  styleUrls: ['./load-chainage.component.css']
})
export class LoadChainageComponent extends DetailComponent {
  chainage: LoadChainageDto;
  queueTitle: string;
  step: number = 2;

  selectedTypeGravelCalc: GravelCalcType[] = [] ;
  @Output()  preSelectedTypeGravelCalc: GravelCalcType[] = [];
  bermHeights: number[];
  baseSprings: number[];
  itemsPrefix: string[];

  constructor(
    public override translate: TranslateService,
    private loadService: LoadChainageControllerService,
    public override sidenavService: SideNavService,
    public override router: Router,
    private formBuilder: UntypedFormBuilder,
    private tunnelSectionService: TunnelSectionControllerService
  ) {
    super(translate, sidenavService, router);
  }

  override ngOnInit()
  {
    this.profilesAllowEdit = 'ADMIN,ENGINEER';
    super.ngOnInit();
  }

  override initItem(): void {
    super.initItem();
    //init an empty dto and set the invisible fields
    this.chainage = {} as any as LoadChainageDto;

    this.initForm();
    this.columnsVisible.set('id', false);
  }

  override getItem(request) {
    super.getItem(request);

    this.loadService.getLoadChainage(request).subscribe((data: LoadChainageDto) => {
      this.chainage = data;
      this.name = data.chainage.toString();

      //to fix to many digits from server sometimes
      this.chainage.loadPoint = Math.round(this.chainage.loadPoint * 1000) / 1000;
      this.chainage.load = Math.round(this.chainage.load * 1000) / 1000;
      this.chainage.loadPoint = Math.round(this.chainage.loadPoint * 1000) / 1000;
      this.chainage.kDistSoil = Math.round(this.chainage.kDistSoil * 1000) / 1000;
      this.chainage.kSubSoil = Math.round(this.chainage.kSubSoil * 1000) / 1000;
      this.chainage.avgNormalStress = Math.round(this.chainage.avgNormalStress * 1000) / 1000;
      this.chainage.gravelSpacing = Math.round(this.chainage.gravelSpacing * 1000) / 1000;
      this.chainage.maxOneFieldLimit = Math.round(this.chainage.maxOneFieldLimit * 1000) / 1000;
      this.chainage.maxOverallLimit = Math.round(this.chainage.maxOverallLimit * 1000) / 1000;
      this.chainage.maxOverallOneFieldLimit = Math.round(this.chainage.maxOverallOneFieldLimit * 1000) / 1000;
      this.chainage.maxOverallTriangleLimit = Math.round(this.chainage.maxOverallTriangleLimit * 1000) / 1000;
      this.chainage.gravelStartPosition = Math.round(this.chainage.gravelStartPosition * 1000) / 1000;


      this.selectedTypeGravelCalc[0] = this.chainage.gravelCalc;
      this.preSelectedTypeGravelCalc = this.selectedTypeGravelCalc;

      this.initForm();
      this.detailForm.controls['id'].disable();
      this.getBermHeights();
      this.getbaseSprings();
    },
    (err: string) => {
      window.alert(err.replace('Object', 'Load/Spring chainage'));
    });
  }

  override setForm() {
    //set visibility fields, set FormGroup and validators
    super.setForm();

    this.columnsVisible = new Map([
      ['id', false],
      ['chainage', true],
      ['loadPoint', true],
      ['load', true],
      ['kDistSoil', false],
      ['kSubSoil', true],
      ['avgNormalStress', true],
      ['gravelSpacing', true],
      ['maxOneFieldLimit', true],
      ['maxOverallLimit', true],
      ['maxOverallOneFieldLimit', true],
      ['maxOverallTriangleLimit', true],
      ['gravelStartPosition', true],
      ['gravelCalc', !this.disableByProfile],
      ['gravelCalc_disabled', this.disableByProfile],
      ['gravelDiffOptimalThick', true],
      ['baseSurveyDiff', true],
      ['bermHeightTarget', true],
      ['baseSpring', true],
      ['name', true]
    ]);

    this.detailForm = this.formBuilder.group({
      id: [''],
      chainage: [{ value: 0, disabled: this.disableByProfile}, Validators.required],
      loadPoint: [{ value: 0, disabled: this.disableByProfile}, Validators.required],
      load: [{ value: 0, disabled: this.disableByProfile}, Validators.required],
      kDistSoil: { value: 0, disabled: this.disableByProfile},
      kSubSoil: { value: 0, disabled: this.disableByProfile},
      avgNormalStress: { value: 0, disabled: true},
      gravelSpacing: { value: 0, disabled: this.disableByProfile},
      maxOneFieldLimit: { value: 0, disabled: this.disableByProfile},
      maxOverallLimit: { value: 0, disabled: this.disableByProfile},
      maxOverallOneFieldLimit: { value: 0, disabled: this.disableByProfile},
      maxOverallTriangleLimit: { value: 0, disabled: this.disableByProfile},
      gravelStartPosition: {value: 0, disabled: this.disableByProfile},
      gravelCalc: {value: '', disabled: this.disableByProfile},
      gravelCalc_disabled: {value: '', disabled: this.disableByProfile},
      gravelDiffOptimalThick: { value: 0, disabled: this.disableByProfile},
      name: { value: '', disabled: this.disableByProfile},
      baseSurveyDiff: { value: 0, disabled: this.disableByProfile},
      bermHeightTarget: { value: 0, disabled: this.disableByProfile},

    }) as ILoadChainageFormGroup;

    //patch value dto to formGroup
    if (this.copy)
      this.copyItem();
    else
      {
        this.detailForm.patchValue(this.chainage);
        this.detailForm.controls['gravelCalc_disabled'].setValue(this.chainage.gravelCalc);
      }
  }

  override initForm() {
    super.initForm();
    this.initDialogDelete('load-chainage.dialog_title');

    //set topmenu icon actions
    this.translate.get(['icon_refresh', 'icon_menu', 'recalculate-queue.title', 'icon_next', 'icon_previous']).subscribe((translations: string) => {
      this.queueTitle = translations['recalculate-queue.title'];
      this.topMenuIcons = [
        {
          icon: 'refresh',
          title: translations['icon_refresh'],
          routerLink: null,
          clickMethod: 'refresh',
          hide: false
        },
        {
          icon: 'arrow_back',
          title: translations['icon_previous'],
          routerLink: null,
          clickMethod: 'navigatePrevious',
          hide: this.hidePrevious
        },
        {
          icon: 'arrow_forward',
          title: translations['icon_next'],
          routerLink: null,
          clickMethod: 'navigateNext',
          hide: this.hideNext
        },
        {
          icon: 'menu',
          title: translations['icon_menu'],
          routerLink: RouterLinkEnum.LOAD_CHAINAGES_LIST.toString(),
          clickMethod: 'dummy',
          hide: false
        },
      ];
    });
    this.setForm();
  }

  getBermHeights()
  {
    let result: number[] = [];
    let prefix: string[] = [];

    let i = 0;
    //alleen even velden bestaan ...
    for (i; i < 43; i=i+2)
    {
      prefix.push(String(i + ' - ' + (i + 2)));
      result.push(this.chainage['bermHeightTarget' + i] ? this.chainage['bermHeightTarget' + i] : 0);
    }
    this.bermHeights = result;
    this.itemsPrefix = prefix;
  }

  getbaseSprings()
  {
    let result: number[] = [];
    let i = 0;
    //alleen even velden bestaan ...
    for (i; i < 43; i=i+2)
    {
      result.push(this.chainage['baseSpring'+ i] ? this.chainage['baseSpring'+ i] : 0);
    }
    this.baseSprings = result;
  }

  changeBermHeight(items: number[])
  {
    let i = 0;
    let x = 0;

    for (i; i < 22; i++)
    {
      this.chainage['bermHeightTarget'+ x] = Number(items[i]);
      x = x+2;
    }
  }

  changeBaseSpring(items: number[])
  {
    let i = 0;
    let x = 0;

    for (i; i < 22; i++)
    {
      this.chainage['baseSpring'+ x] = Number(items[i]);
      x = x+2;
    }
  }



  setStep(index: number) {
    this.step = index;
  }

  override saveOk() {
    super.saveOk();
    Object.assign(this.chainage, this.detailForm.value);
    this.chainage.gravelCalc = this.selectedTypeGravelCalc[0];

    var response =
      this.id !== 'new' && !this.copy
        ? this.loadService.updateLoadChainage({
            id: this.id,
            body: this.chainage,
          })
        : this.loadService.createLoadChainage({ body: this.chainage });

    response.subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        if (this.id === 'new' || this.copy)
        {
          this.router.navigateByUrl(RouterLinkEnum.LOAD_CHAINAGES.toString() + data.id);
        }
        else
        {
          this.refresh();
        }
      },
      (err) => {
        this.sidenavService.setLoading(false);
        console.log('Load chainage not created/updated');
        window.alert('Create/update load chainage not possible');
      }
    );
  }

  override delete() {
    super.delete();

    this.loadService.deleteLoadChainage({ id: this.id }).subscribe(
      (data) => {
        this.sidenavService.setLoading(false);
        this.router.navigateByUrl(RouterLinkEnum.LOAD_CHAINAGES_LIST.toString());
        console.log('item deleted successfully!');
      },
      (error) => {
       this.sidenavService.setLoading(false);
        console.log(error.error.message);
        window.alert('Delete load chainage not possible');
      }
    );
  }

  override copyItem(): void {
    super.copyItem();

    this.chainage.chainage++;
    this.chainage.id = null;
    //patch value dto to formGroup
    this.detailForm.patchValue(this.chainage);
    this.detailForm.controls['gravelCalc_disabled'].setValue(this.chainage.gravelCalc);
  }

recalculateSections()
{
  //use a confirmDialog box before recalculate
  let recalculateConfirmText = this.translate.instant('load-chainage.recalculate-all-confirm');
  let recalculateDialogTitleText = this.translate.instant('load-chainage.recalculate-dialog-title');
  const recalculateConfirmDialog = this.dialog.open(AlertComponent, {
    data: {message: recalculateConfirmText, type: recalculateDialogTitleText, buttonCancel: this.buttonCancel, buttonConfirm: this.buttonConfirm }, hasBackdrop: true }

  );
  recalculateConfirmDialog.afterClosed().subscribe(result => {
    if (result === true) {
      this.recalculate();
    }
  });
}

recalculate()
{
  this.sidenavService.setLoading(true);
  this.tunnelSectionService.calculateAll().subscribe(
    (data) => {
      this.sidenavService.setLoading(false);
      this.showPopupQueue();
    },
    (error) => {
      window.alert(this.translate.instant('load-chainage.recalculate-all-failed'));
      this.sidenavService.setLoading(false);
    }
  );
}

showPopupQueue() {

  let popupDialog = this.dialog.open(DialogRecalucateQueueComponent, {
    data: {  buttonCancel: 'Close' }, hasBackdrop: true
  }
  );
  popupDialog.afterClosed().subscribe(result => {
    popupDialog = null;
  });
}

setSelectedTypeGravelCalc(types: GravelCalcType[])
  {
    this.selectedTypeGravelCalc = types;
  }
}



